import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController, Events, NavParams } from 'ionic-angular';
import { ApiBaseProvider } from '../api-base-service/api-base-service';


@Injectable()
export class ApiServiceProvider extends ApiBaseProvider {

  constructor(
    public http: HttpClient,
    protected toastController: ToastController,
    protected alertController: AlertController,
    protected loadingController: LoadingController,
    protected events: Events,
  ) {
    super(http, toastController, alertController, loadingController, events);
    console.log('Hello ApiServiceProvider Provider');
  }

  //*********************
  //*  共通処理  *
  //*********************
  // - 自動ログイン
  loginJPUC(data: any) {
    let showLoading = false;
    let showErrorMessage = false;
    return this.post(`${this.apiUrl}/api/v1/jpuc-users/autologin`, data, showLoading, showErrorMessage);
  }

  // - ログイン処理
  signIn(data: any, showErrorMessage: boolean = true) {
    let showLoading = true;
    return this.post(`${this.apiUrl}/api/v1/login`, data, showLoading, showErrorMessage);
  }

  // - ログアウト
  signOut() {
    return this.post(`${this.apiUrl}/api/v1/logout`, {});
  }

  inquiry(params: any) {
    return this.post(`${this.apiUrl}/api/v1/inquiry`, params);
  }

  // - PDFファイルのアップロード
  uploadFile(data: {}): Promise<any> {
    let loading = this.loadingController.create();
    loading.present();
    return this.http.post(`${this.apiUrl}/api/v1/admin/files`, data, { headers: this.getHeadersForImage()}).toPromise().then((res:any) => {
      loading.dismiss();
      return res;
    }).catch((error:any) => {
      loading.dismiss();
      return Promise.reject(error);
    });
  }


  //*********************
  //*  協会が利用するAPI  *
  //*********************

  //*** 企業情報 ***
  // - 企業情報を取得
  getOffices(query:any = {}) {
    let url = `${this.apiUrl}/api/v1/admin/offices`;
    if (query.target) {
      url += `?target=${query.target}`;
    }
    return this.get(url);
  }
  // - 企業情報の登録
  postOffice(params: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/offices`, params);
  }
  // - 企業情報の更新
  updateOffice(officeId: string, params: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/offices/${officeId}`, params);
  }
  // - 企業情報の削除
  deleteOffice(officeId) {
    return this.delete(`${this.apiUrl}/api/v1/admin/offices/${officeId}`);
  }
  // - 企業情報の更新
  updateAdminUserLicense(userId: string, params: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/users/${userId}/license`, params);
  }

  // *** コンテンツ情報 ***
  // - コンテンツの取得
  getContents() {
    return this.get(`${this.apiUrl}/api/v1/admin/contents`);
  }
  // - コンテンツの登録
  createContent(data:any) {
    return this.post(`${this.apiUrl}/api/v1/admin/contents`, data);
  }
  // - コンテンツの更新
  updateContent(contentId:string, data) {
    return this.post(`${this.apiUrl}/api/v1/admin/contents/${contentId}`, data);
  }

  getContentStatus(query:any = {}) {
    let url = `${this.apiUrl}/api/v1/admin/contents/questions/status?`;
    if (query.contentId) url += `contentId=${query.contentId}&`;
    if (query.officeId) url += `officeId=${query.officeId}&`;
    if (query.isPassd) url += `isPassd=${query.isPassd}&`;
    if (query.userTestNumber) url += `userTestNumber=${query.userTestNumber}&`;
    if (query.userName) url += `userName=${query.userName}&`;
    return this.get(`${url}`);

  }
  
  // *** 教材の情報 ***
  // - 教材リストの取得
  getContentMaterials(contentId: string) {
    return this.get(`${this.apiUrl}/api/v1/admin/materials?contentId=${contentId}`);
  }
  // - 教材の登録
  createMaterial(data: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/materials`, data);
  }
  // - 教材の更新
  updateMaterial(materialId:string, data:any) {
    return this.post(`${this.apiUrl}/api/v1/admin/materials/${materialId}`, data);
  }

  // *** 試験の情報 ***
  // - 試験の取得(詳細)
  getQuestion(questionId: string) {
    return this.get(`${this.apiUrl}/api/v1/admin/questions/${questionId}`);
  }

  // - 試験の登録
  createQuestion(data: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/questions`, data);
  }
  // - 試験の更新
  updateQuestion(questionId:string, data: any) {
    return this.post(`${this.apiUrl}/api/v1/admin/questions/${questionId}`, data);
  }
  // - 試験の削除
  deleteQuestion(questionId:string) {
    return this.delete(`${this.apiUrl}/api/v1/admin/questions/${questionId}`);
  }


  getLearningStatus() {
    return this.get(`${this.apiUrl}/api/v1/admin/learning/status`);
  }

  // 検索条件に応じてユーザのリストを取得する
  getAdminUserList(params:any = {}) {
    let data = this.getParams(params);
    console.log(data);
    return this.get(`${this.apiUrl}/api/v1/admin/users`, data);
  }

  // ユーザ情報の企業と所属のみを変更出来るAPI
  updateUserByAdmin(userId, params:any = {}) {
    return this.post(`${this.apiUrl}/api/v1/admin/users/${userId}`, params);    
  }

  // - 問い合わせ一覧を取得する
  getAdminInquiry() {
    return this.get(`${this.apiUrl}/api/v1/admin/inquiries`);
  }



  //*********************
  //*  受講者が利用するAPI *
  //*********************

  //*** eラーニング関連 ***
  // - 学習可能な教材の取得
  getUserContents() {
    return this.get(`${this.apiUrl}/api/v1/user/contents`);
  }
  getUserContentMaster(userId) {
    return this.get(`${this.apiUrl}/api/v1/users/${userId}/contents/invite-master`);
  }
  inviteUserContent(userId, params = {}) {
    return this.post(`${this.apiUrl}/api/v1/users/${userId}/contents`, params);
  }

  

    

  // - 教材の取得と学習の開始
  getUserMaterial(materialId:string) {
    return this.get(`${this.apiUrl}/api/v1/user/materials/${materialId}`);
  }

  // - 試験問題の取得と試験開始
  getUserMaterialQuestion(materialId:string) {
    return this.get(`${this.apiUrl}/api/v1/user/materials/${materialId}/questions`);
  }

  startQuestion(materialId:string, questionId:string, data:any = {}) {
    return this.post(`${this.apiUrl}/api/v1/user/materials/${materialId}/questions/${questionId}/start`, data);
  }


  // - 試験問題の回答
  sendUserQuestionAnswer(materialId:string, questionId:string, data) {
    return this.post(`${this.apiUrl}/api/v1/user/materials/${materialId}/questions/${questionId}/answer`, data);
  }

  //*** ユーザ関連 ***
  // - ユーザの一覧を取得する
  getUserList(query) {
    let url = `${this.apiUrl}/api/v1/users`;
    if (query.status) {
      url += `?status=${query.status}`;
    }
    return this.get(url);
  }

  getUserQuestionLogs(userId: string) {
    return this.get(`${this.apiUrl}/api/v1/users/${userId}/contents/logs`);
  }    

  // - ユーザを登録する
  createUser(data: any, showLoading :boolean = true, showErrorMessage: boolean = true)  {
    return this.post(`${this.apiUrl}/api/v1/users`, data, showLoading, showErrorMessage);
  }

  // - ユーザを変更する
  updateUser(userId: string, data: any) {
    return this.post(`${this.apiUrl}/api/v1/users/${userId}`, data);
  }

  // - ユーザを削除する
  deleteUser(userId: string) {
    return this.delete(`${this.apiUrl}/api/v1/users/${userId}`);
  }
  

  // - ユーザの一覧を取得する
  getOfficeBrancheList() {
    return this.get(`${this.apiUrl}/api/v1/user-office-branches`);
  }

  // 企業情報認証
  jpucCheckOffice(data: any) {
    return this.post(`${this.apiUrl}/api/v1/jpuc-users/check`, data);
  } 

  jpucCreateUser(data: any) {
    return this.post(`${this.apiUrl}/api/v1/jpuc-users/create`, data);
  }

}




// WEBPACK FOOTER //
// ./src/providers/api-service/api-service.ts